import VisibilityBanners from './VisibilityBanners.component';

export default VisibilityBanners;
